import { buildArticle } from "./_articleBuilder";

export default buildArticle({
  slug: "can-you-take-antidepressants-during-tms",
  title: "Can You Take Antidepressants During TMS?",
  description:
    "TMS may be used alongside oral antidepressants. Learn how medication and TMS work together and why you should never stop medication without consulting your prescriber.",
  keywords:
    "antidepressants during TMS, TMS and medication, can I take medication with TMS, stop medication before TMS",
  badge: "Educational Article",
  heroTitle: "Can You Take Antidepressants During TMS?",
  heroSubtitle:
    "Yes, TMS may be used alongside oral antidepressants. Whether that's appropriate for you is a clinical decision — and you should never stop medication on your own.",
  sections: [
    {
      heading: "TMS and Medication Are Not Mutually Exclusive",
      body: "TMS is a non-medication treatment, but that doesn't mean you need to stop your current medication to receive it. Many people continue taking antidepressants during a TMS course. Whether that's appropriate depends on your situation.",
    },
    {
      heading: "Do Not Stop Medication on Your Own",
      body: "If you are currently taking antidepressants, do not stop, change, or adjust your medication without discussing it with your prescribing healthcare provider. Stopping medication suddenly can cause problems.",
      callout: true,
    },
    {
      heading: "How the Decision Is Made",
      body: "Whether to continue, adjust, or change medication during TMS is a decision made between you, your prescriber, and your TMS care team. Your full medication history is part of the consultation.",
    },
    {
      heading: "If You're Starting a New Medication",
      body: "If you're starting a new antidepressant, it's often worth allowing adequate time to assess its effect before exploring other options. Your prescriber can help you think through the timing.",
    },
  ],
  faq: [
    {
      question: "Do I have to stop my medication before TMS?",
      answer:
        "No. TMS does not require you to stop medication. Many people continue taking antidepressants during TMS. Do not stop or change medication without discussing it with your prescribing provider.",
    },
    {
      question: "Will TMS interfere with my medication?",
      answer:
        "TMS works through a different mechanism than oral medication and generally does not interfere. Your care team reviews your full medication list during consultation to ensure everything is coordinated.",
    },
  ],
  related: [
    {
      title: "When Antidepressants Aren't Enough",
      href: "/when-antidepressants-dont-work",
    },
    { title: "Medications After TMS", href: "/medications-after-tms" },
    {
      title: "Depression Treatment Options",
      href: "/depression-treatment-options",
    },
  ],
  finalCtaText:
    "Questions about medication and TMS are important. Speak with our team about how your treatment plan is coordinated.",
});
